import { useMemo, useEffect } from 'react'
import { IssueStatus, IssueType, ProjectStatus } from '../../api/shared'

export interface UseDetermineJiraStatusesParameters {
  projectStatuses?: ProjectStatus[]
  issueType?: IssueType | string
  onUpdate: (matchingStatus: IssueStatus[]) => void
}
export const useDetermineJiraStatusesFromIssueType = ({
  projectStatuses,
  issueType,
  onUpdate
}: UseDetermineJiraStatusesParameters) => {
  const issueTypeId = useMemo(() => {
    return typeof issueType === 'string' ? issueType : issueType?.id
  }, [issueType])
  const matchingIssueTypeStatuses = useMemo(() => {
    if (projectStatuses && typeof issueType === 'object') {
      return (
        projectStatuses.find((jiraStatus) => jiraStatus.name === issueType.name)
          ?.statuses ?? []
      )
    }
    return []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [issueTypeId, projectStatuses])

  useEffect(() => {
    onUpdate(matchingIssueTypeStatuses)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchingIssueTypeStatuses])
}
